import styled from "@emotion/styled";
import theme from "../../styles/theme";
import GatsbyLink from "../link/link";

export const HeroContentPostBase = styled.div`
  margin-bottom: ${theme.spacing[4]};
  padding: 0 ${theme.spacing[4]};

  ${theme.largerThan["2xl"]} {
    padding: 0;
  }
`;

export const Wrapper = styled.div`
  max-width: ${theme.maxWidth};
  margin: 0 auto;

  ${theme.largerThan.md} {
    display: grid;
    grid-template-columns: repeat(12, minmax(0, 1fr));
    gap: 1rem;
    padding-bottom: ${theme.spacing[4]};
    border-bottom: 1px solid ${theme.colors.darkBlues[10]};
  }
`;

export const Text = styled.div`
  ${theme.largerThan.md} {
    grid-column: span 9 / span 9;
    gap: 1rem;
    padding-right: ${theme.spacing[8]};
  }
`;

export const Title = styled.h1``;

export const MetaText = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;
  margin-bottom: 2rem;
  color: ${theme.colors.darkBlues[75]};

  ${theme.largerThan.md} {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
`;

export const Author = styled.div`
  display: flex;
  gap: 0.25rem;
`;

export const AuthorImage = styled.img`
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
`;

export const AuthorTextWrapper = styled.div``;

export const AuthorText = styled.div`
  font-size: ${theme.fontSizes[0]};
`;

export const AuthorName = styled.div`
  font-size: ${theme.fontSizes[1]};
  font-weight: ${theme.fontWeights.semibold};
  color: ${theme.colors.darkBlues[100]};
`;

export const ReadTime = styled.div`
  font-size: ${theme.fontSizes[0]};
`;

export const Subtitle = styled.p`
  font-size: ${theme.fontSizes[3]};
  line-height: ${theme.leading.normal};
  color: ${theme.colors.darkBlues[100]};
`;

export const ImageWrapper = styled.div`
  grid-column: span 3 / span 3;

  img {
    border-radius: 0.25rem;
  }
`;

export const AuthorLink = styled(GatsbyLink)`
  color: ${theme.colors.darkBlues[100]};
`;

export const AuthorSuffix = styled.span`
  font-size: ${theme.fontSizes[0]};
  font-weight: ${theme.fontWeights.regular};
  color: ${theme.colors.darkBlues[75]};
`;
